import { render, staticRenderFns } from "./SwitchAtivoField.vue?vue&type=template&id=7fc265d6&scoped=true&"
import script from "./SwitchAtivoField.vue?vue&type=script&lang=js&"
export * from "./SwitchAtivoField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAtivoField.vue?vue&type=style&index=0&id=7fc265d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc265d6",
  null
  
)

export default component.exports